import React from "react";
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from "recharts";

const COLORS = ["#4a90e2", "#8e44ad", "#27ae60", "#f39c12", "#e74c3c"];

const ErrorDistributionChart = ({ reports_by_type }) => {
   let chartData = [];
   let totalErrors = 0;

   if (reports_by_type) {
      chartData = Object.entries(reports_by_type).map(([key, value]) => ({
         name: key.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase()),
         value,
      }));
      totalErrors = chartData.reduce((sum, entry) => sum + entry.value, 0);
   }

   console.log("reports_by_type_json in GlobalDashboard:", reports_by_type);
   console.log("Parsed chartData:", chartData);
   console.log("Total errors:", totalErrors);

   return (
      <div className="content-card">
         <div className="card-header">
            <h3 className="card-title">
               <i className="bi bi-pie-chart"></i>
               Error Distribution
            </h3>
         </div>
         <div className="chart-container">
            {totalErrors > 0 ? (
               <ResponsiveContainer width="100%" height={300}>
                  <PieChart>
                     <Pie
                        data={chartData}
                        cx="50%"
                        cy="50%"
                        outerRadius={80}
                        fill="#8884d8"
                        dataKey="value"
                        labelLine={false}
                        label={({ cx, cy, midAngle, innerRadius, outerRadius, percent }) => {
                           if (percent === 0) return "";
                           const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
                           const x = cx + radius * Math.cos(-midAngle * (Math.PI / 180));
                           const y = cy + radius * Math.sin(-midAngle * (Math.PI / 180));
                           return (
                              <text
                                 x={x}
                                 y={y}
                                 fill="white"
                                 textAnchor="middle"
                                 dominantBaseline="central"
                              >
                                 {`${(percent * 100).toFixed(0)}%`}
                              </text>
                           );
                        }}
                     >
                        {chartData.map((entry, index) => (
                           <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                        ))}
                     </Pie>
                     <Tooltip />
                     <Legend />
                  </PieChart>
               </ResponsiveContainer>
            ) : (
               <div className="empty-state">
                  <i className="bi bi-bar-chart"></i>
                  <p>No error report data available</p>
               </div>
            )}
         </div>
      </div>
   );
};

export default ErrorDistributionChart;
